import React from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { HowItWorks } from '../components/HowItWorks';
import { ValueProposition } from '../components/ValueProposition';
import { WaysToJoin } from '../components/WaysToJoin';
import { UseCases } from '../components/UseCases';
import { ProductDeepDive } from '../components/ProductDeepDive';
import { TrustSecurity } from '../components/TrustSecurity';
import { Pricing } from '../components/Pricing';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-562" data-mp="2dj1m8sn1nf7y">
      <SEO title="KittyPot | Group Money Made Simple" description="Create shared pots, track expenses and settle up together. KittyPot shows who owes who and lets your group settle directly, in the app or from a web invite link." ogTitle="KittyPot | Group Money Made Simple" ogDescription="Create shared pots, track expenses, settle up together." path="/" jsonLd={{
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'KittyPot',
      url: 'https://www.kittypot.com',
      description: 'KittyPot is a shared expense pot for friends, trips and housemates. Create a group, track who paid what, see who owes who, and settle up together in the app or from a web invite link.'
    }} data-id="element-563" data-mp="3kxd1t5hk42zq" />
      <Navbar data-id="element-564" data-mp="2d5dwe9e5zzu1" />
      <main data-id="element-565" data-mp="287ujpdx47v47">
        <HeroSection data-id="element-566" data-mp="287kpfe51f1sp" />
        <ProblemSection data-id="element-567" data-mp="288vv5ji1mjmg" />
        <HowItWorks data-id="element-568" data-mp="288du89kfrh87" />
        <ValueProposition data-id="element-569" data-mp="23915tkdx223i" />
        <WaysToJoin data-id="element-570" data-mp="239soxvqbu7cw" />
        <UseCases data-id="element-571" data-mp="23ac6vcfz8vqx" />
        <ProductDeepDive data-id="element-572" data-mp="23auboxgpgiag" />
        <Pricing data-id="element-573" data-mp="1z7fvo6sro1x0" />
        <TrustSecurity data-id="element-574" data-mp="1z7xpyxvvc62a" />
        <FinalCTA data-id="element-575" data-mp="1z6eb9bpv232m" />
      </main>
      <Footer data-id="element-576" data-mp="1z9ijqlaczkz3" />
    </div>;
}